export const pushBlockedCtnActionEvent = (actionType, eventType, isAutoTrackingEvent) => {
  const formNames = {
    blockCtn: 'Заблокировать номер',
    unblockCtn: 'Разблокировать номер',
    cancelFutureStatusRequest: 'Отменить блокировку',
  };

  const eventActions = {
    blockCtn: `block_ctn_${eventType}`,
    unblockCtn: `unblock_ctn_${eventType}`,
    cancelFutureStatusRequest: `unblock_ctn_${eventType}`,
  };

  if (eventType) {
    window.dataLayer.push({
      event: 'event_az_applForm',
      eventAction: eventActions[actionType],
      formName: formNames[actionType],
    });
  } else if (isAutoTrackingEvent) {
    window.dataLayer.push({
      event: 'autotracking',
      action: 'spanClick',
      eventText: formNames[actionType],
    });
  } else {
    window.dataLayer.push({
      event: 'event_az_applForm_changeField',
      eventAction: 'changeField',
      fieldName: 'date',
      formName: formNames[actionType],
    });
  }
};
